import script from "./Customer-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer-big.vue?vue&type=script&setup=true&lang=js"

import "./Customer-big.vue?vue&type=style&index=0&id=a666ada0&scoped=true&lang=css"
import "./Customer-big.vue?vue&type=style&index=1&id=a666ada0&scoped=true&lang=css"
import "./Customer-big.vue?vue&type=style&index=2&id=a666ada0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a666ada0"]])

export default __exports__